import { Ability, AbilityBuilder, AbilityClass } from '@casl/ability';
import { IArxeiaConfiguration, IFascicolo, IFeature, IForwardRule, IMailbox, IMailPecMail, IPrintAndSend, IProtocol, IProtocolloAreaDiLavoro, IProtocolRegister, ITitolario, IUor, IUser, IUserAoo } from '../interfaces'


type CRUD = 'create' | 'read' | 'update' | 'delete';
type Abilities = ['create' | 'read' | 'update' | 'sign', IProtocol | 'IProtocol']
    | [CRUD, IUor | 'IUor' | IUser | 'IUser' | ITitolario | 'ITitolario' | IForwardRule | 'IForwardRule' | IFascicolo | 'IFascicolo'
    | IFeature | 'IFeature' | IArxeiaConfiguration | 'IArxeiaConfiguration' | IMailbox | 'IMailbox' | IProtocolloAreaDiLavoro |'IProtocolloAreaDiLavoro']
    | ['read' | 'protocol', IMailPecMail | 'IMailPecMail']
    | ['read' | 'send', IPrintAndSend | 'IPrintAndSend']
    | ['read', IProtocolRegister | 'IProtocolRegister']
    | ['use', IFeature | 'IFeature'];

export type AppAbility = Ability<Abilities>;
export const AppAbility = Ability as AbilityClass<AppAbility>;


const { build } = new AbilityBuilder(AppAbility);


export default build();




